import {
    FiberPinRounded as FiberPinRoundedIcon,
    VisibilityOffOutlined as VisibilityOffOutlinedIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Box,
    Button,
    CardContent,
    FormControl,
    FormControlLabel,
    InputAdornment,
    Switch,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import api from '../../../services/api';
import React, { Component } from 'react';
import { ANAO, ASIM } from '../../../consts';
import { isInvalidSelect } from 'lib/configUtils';
import ComboPadrao from 'views/Components/ComboPadrao';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { validateField, generateRandomPwd, getCodUsuarioRegistrou } from 'lib/functions';

class UsuarioPartnerForm extends Component {
    state = {
        usuariopartner: {
            id: '',
            nomeusuario: '',
            email: '',
            senha: '',
            codfornecedor: '',
            inativousuario: ANAO
        },
        confirmPwd: '',
        errors: {},
        openAlert: false,
        messageAlert: '',
        fornecedores: [],
        isNewRecord: false,
        isView: false,
        showPwd: false,
        showConfirmPwd: false,
        schema: {
            nomeusuario: {
                presence: { allowEmpty: false, message: 'Nome de usuário obrigatório!' },
                length: { maximum: 100 },
                type: 'string'
            },
            email: {
                presence: { allowEmpty: false, message: 'E-mail inválido!' },
                length: { maximum: 100 },
                type: 'string'
            },
            senha: {
                presence: { allowEmpty: false, message: 'Senha obrigatória!' },
                length: { maximum: 8 },
                type: 'string'
            },
            codfornecedor: {
                presence: { allowEmpty: false, message: 'Fornecedor obrigatório!' },
                length: { maximum: 100 },
                type: 'integer'
            }
        }
    };

    /* Alterna a visibilidade da senha */
    handleToggleShowPassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.toggleShowPassword();
        }
    };

    /* Alterna a visibilidade da confirmação de senha */
    handleToggleShowConfirmPassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.toggleShowConfirmPassword();
        }
    };

    /* Altera a cor do ícone de senha ao passar o cursor */
    handlePasswordIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#8e9091';
    };

    /* Retorna à cor padrão do ícone de senha ao remover o cursor */
    handlePasswordIconMouseLeave = (event) => {
        event.currentTarget.style.color = '#707172';
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;

        try {
            await this.loadFornecedores();

            if (!isNaN(Number(id))) {
                await this.loadUsuariosPartner(id, location.pathname.includes('/view'));
            } else if (id === 'novo') {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    usuariopartner: this.getUsuarioPartnerDefault()
                });
            }
        } catch (error) {
            console.error('Erro ao carregar usuário partner:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar usuário partner!'
            );
        }
    };

    /* Retorna o usuário partner padrão */
    getUsuarioPartnerDefault = () => ({
        id: '',
        nomeusuario: '',
        email: '',
        senha: '',
        codfornecedor: '',
        inativousuario: ANAO
    });

    /* Carrega os fornecedores */
    loadFornecedores = async () => {
        const params = '?page=1&limit=500&tbfornecedor.transportadora=S';
        const response = await api.get(`/fornecedor/active/true${params}`);

        this.setState({ fornecedores: response.data });
    };

    /* Carrega os usuários partner */
    loadUsuariosPartner = async (id, isView) => {
        const response = await api.get(`/usuariopartner/${id}`);
        const dados = response?.data?.data?.[0] || {};

        this.setState({
            usuariopartner: {
                ...dados,
                inativousuario: dados.inativousuario || ANAO
            },
            confirmPwd: dados.senha || '',
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { usuariopartner } = this.state;
        const { name, value, checked } = event.target;

        let newValue = value;

        if (name === 'nomeusuario') {
            newValue = value.toUpperCase();
        }

        if (name === 'senha' || name === 'confirmPwd') {
            newValue = value.toUpperCase();
        }

        if (name === 'inativousuario') {
            newValue = checked ? ANAO : ASIM;
        }

        if (name === 'confirmPwd') {
            this.setState({ confirmPwd: newValue });

            return;
        }

        this.setState({
            usuariopartner: {
                ...usuariopartner,
                [name]: newValue
            }
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de usuário partner */
    getPayloadUsuarioPartner = () => {
        const { usuariopartner } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        return {
            codfornecedor: usuariopartner.codfornecedor || '',
            nomeusuario: usuariopartner.nomeusuario || '',
            email: usuariopartner.email || '',
            senha: usuariopartner.senha || '',
            inativousuario: usuariopartner.inativousuario || ANAO,
            codusuarioregistrou
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { confirmPwd, isNewRecord, usuariopartner } = this.state;
        const { history, loadUsuariosPartner } = this.props;

        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        if ((usuariopartner.senha || '') !== (confirmPwd || '')) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    confirmPwd: 'As senhas não coincidem!'
                }
            }));

            this.handleOpenAlert('As senhas não coincidem!');

            return;
        }

        if (isInvalidSelect(usuariopartner.codfornecedor)) {
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    codfornecedor: 'Selecione um fornecedor válido!'
                }
            }));

            this.handleOpenAlert('Selecione um fornecedor válido!');

            return;
        }

        try {
            const payload = this.getPayloadUsuarioPartner();

            if (isNewRecord) {
                await api.post('/usuariopartner', payload);
            } else {
                await api.put(`/usuariopartner/${usuariopartner.id}`, payload);
            }

            if (loadUsuariosPartner) loadUsuariosPartner();

            history.push('/admpartner/usuariopartner');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao salvar!'
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/admpartner/usuariopartner');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema, usuariopartner } = this.state;
        let errors = {};

        // valida os campos do schema
        const requiredFields = [
            'nomeusuario',
            'email',
            'senha',
            'codfornecedor'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, usuariopartner[field], schema);

            if (error) {
                errors[field] = error;
            }
        });

        return errors;
    };

    /* Alterna a visibilidade da senha */
    toggleShowPassword = () => {
        this.setState(prev => ({ showPwd: !prev.showPwd }));
    };

    /* Alterna a visibilidade de confirmação da senha */
    toggleShowConfirmPassword = () => {
        this.setState(prev => ({ showConfirmPwd: !prev.showConfirmPwd }));
    };

    /* Gera a senha */
    onClickGeneratePassword = () => {
        const { isView } = this.state;

        if (!isView) {
            this.handleGeneratePwd();
        }
    };

    /* Gera uma senha aleatória */
    handleGeneratePwd = () => {
        const pwd = generateRandomPwd(8);

        this.setState(prev => ({
            usuariopartner: {
                ...prev.usuariopartner,
                senha: pwd
            },
            confirmPwd: pwd
        }));
    };

    render() {
        const {
            confirmPwd,
            errors,
            fornecedores,
            isNewRecord,
            isView,
            messageAlert,
            openAlert,
            showConfirmPwd,
            showPwd,
            usuariopartner
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{
                            flexWrap: 'wrap',
                            gap: 12
                        }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Usuário {usuariopartner.id}
                        </Typography>

                        <FormControlLabel
                            label={(usuariopartner.inativousuario === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={usuariopartner.inativousuario !== ASIM}
                                    name="inativousuario"
                                    onChange={this.onChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{
                            gap: 12,
                            marginTop: 10
                        }}
                    >
                        <TextField
                            label="Nome do usuário"
                            name="nomeusuario"
                            value={usuariopartner.nomeusuario || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.nomeusuario || ''}
                            error={!!errors.nomeusuario}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                flex: '0 1 300px',
                                minWidth: 300
                            }}
                        />

                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{
                                flex: '0 1 400px',
                                minWidth: 300
                            }}
                        >
                            <ComboPadrao
                                name={'codfornecedor'}
                                label={'Fornecedor'}
                                value={usuariopartner.codfornecedor}
                                onChange={this.onChange}
                                fieldId={'codfornecedor'}
                                listItems={fornecedores}
                                fieldDescription={'fantasia'}
                                helperText={errors.codfornecedor || ''}
                                error={!!errors.codfornecedor}
                            />
                        </FormControl>
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="E-mail"
                            name="email"
                            value={usuariopartner.email || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type="email"
                            autoComplete="email"
                            inputMode="email"
                            helperText={errors.email || ''}
                            error={!!errors.email}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                flex: '0 1 500px',
                                minWidth: 300
                            }}
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        alignItems="flex-start"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Senha"
                            name="senha"
                            value={usuariopartner.senha || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.senha || ''}
                            error={!!errors.senha}
                            disabled={isView}
                            inputProps={{ maxLength: 8 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip
                                            title="Ver/ocultar senha"
                                            enterDelay={50}
                                        >
                                            <span>
                                                {showPwd ? (
                                                    <VisibilityOffOutlinedIcon
                                                        onClick={this.handleToggleShowPassword}
                                                        onMouseEnter={this.handlePasswordIconMouseEnter}
                                                        onMouseLeave={this.handlePasswordIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlinedIcon
                                                        onClick={this.handleToggleShowPassword}
                                                        onMouseEnter={this.handlePasswordIconMouseEnter}
                                                        onMouseLeave={this.handlePasswordIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                flex: '0 1 250px',
                                minWidth: 250
                            }}
                        />

                        <TextField
                            label="Confirmar senha"
                            name="confirmPwd"
                            value={confirmPwd || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            type={showConfirmPwd ? 'text' : 'password'}
                            autoComplete={isNewRecord ? 'new-password' : 'current-password'}
                            helperText={errors.confirmPwd || ''}
                            error={!!errors.confirmPwd}
                            disabled={isView}
                            inputProps={{ maxLength: 8 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Tooltip
                                            title="Ver/ocultar senha"
                                            enterDelay={50}
                                        >
                                            <span>
                                                {showConfirmPwd ? (
                                                    <VisibilityOffOutlinedIcon
                                                        onClick={this.handleToggleShowConfirmPassword}
                                                        onMouseEnter={this.handlePasswordIconMouseEnter}
                                                        onMouseLeave={this.handlePasswordIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                ) : (
                                                    <VisibilityOutlinedIcon
                                                        onClick={this.handleToggleShowConfirmPassword}
                                                        onMouseEnter={this.handlePasswordIconMouseEnter}
                                                        onMouseLeave={this.handlePasswordIconMouseLeave}
                                                        style={{
                                                            fontSize: 22,
                                                            color: '#707172',
                                                            cursor: isView ? 'default' : 'pointer'
                                                        }}
                                                    />
                                                )}
                                            </span>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                            style={{
                                flex: '0 1 250px',
                                minWidth: 250
                            }}
                        />

                        <Tooltip
                            title="Gerar senha"
                            enterDelay={50}
                        >
                            <FiberPinRoundedIcon
                                onClick={this.onClickGeneratePassword}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#356b87'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#2b576e'}
                                style={{
                                    fontSize: 32,
                                    color: '#2b576e',
                                    cursor: isView ? 'default' : 'pointer',
                                    marginTop: 10
                                }}
                            />
                        </Tooltip>
                    </Box>

                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default UsuarioPartnerForm;